import { NativeAudio } from './index';

let currentTrackUrl = null;
let isLoaded = false;
let isPlaying = false;
let eqEnabled = false;

export const nativeAudioPlayer = {
  async load(url) {
    if (!url) throw new Error('NativeAudioPlayer: missing url');

    console.log('[NativeAudioPlayer] load', url);

    currentTrackUrl = url;
    isLoaded = false;
    isPlaying = false;

    const res = await NativeAudio.load({
      url,
      title: 'Hearen',
      artist: 'Personalized sound'
    });

    isLoaded = true;
    return res;
  },

  async play() {
    if (!isLoaded) {
      throw new Error('NativeAudioPlayer: no track loaded');
    }

    console.log('[NativeAudioPlayer] play');

    const res = await NativeAudio.play();
    isPlaying = true;
    return res;
  },

    async preloadNext(url) {
    if (!url) throw new Error('NativeAudioPlayer: missing preload url');

    console.log('[NativeAudioPlayer] preloadNext', url);

    return NativeAudio.preloadNext({
      url
    });
  },

  async crossfadeToPreloaded(duration = 6.0) {
    console.log('[NativeAudioPlayer] crossfadeToPreloaded', { duration });

    return NativeAudio.crossfadeToPreloaded({
      duration
    });
  },

  async pause() {
    console.log('[NativeAudioPlayer] pause');

    const res = await NativeAudio.pause();
    isPlaying = false;
    return res;
  },

  async stop() {
    console.log('[NativeAudioPlayer] stop');

    const res = await NativeAudio.stop();

    isPlaying = false;
    isLoaded = false;
    currentTrackUrl = null;
    eqEnabled = false;

    return res;
  },

  async setEQ({ frequency = 1000, gain = 0, bandwidth = 1, enabled = true }) {


    return NativeAudio.setEQ({
      frequency,
      gain,
      bandwidth,
      enabled
    });
  },

  async enableTestEQ() {
    return this.setEQ({
      frequency: 1000,
      gain: 12,
      bandwidth: 1,
      enabled: true
    });
  },

  async disableEQ() {
    return this.setEQ({
      frequency: 1000,
      gain: 0,
      bandwidth: 1,
      enabled: false
    });
  },
    async setMultiBandEQ(bands = []) {
    console.log('🎛️ [NativeAudioPlayer] setMultiBandEQ', bands);

    eqEnabled = bands.length > 0;

    return NativeAudio.setMultiBandEQ({
      enabled: bands.length > 0,
      bands
    });
  },
  async playVoice(url, volume = 0.75, duckVolume = 0.35) {
  if (!url) throw new Error('NativeAudioPlayer: missing voice url');

  console.log('[NativeAudioPlayer] playVoice', { url, volume, duckVolume });

  return NativeAudio.playVoice({
    url,
    volume,
    duckVolume
  });
},

  getState() {
    return {
      currentTrackUrl,
      isLoaded,
      isPlaying,
      eqEnabled
    };
  }
};